<mat-table [dataSource]="angularMatData" matSort matSortDisableClear matSortActive="AttendanceDate" matSortDirection="desc"
    style="width: 100%" aria-label="Attendance Details Table" tabindex="-1">
    <ng-container matColumnDef="Day">
        <mat-header-cell *matHeaderCellDef style="min-width:75px;max-width: 75px;"></mat-header-cell>
        <mat-cell *matCellDef="let detail" style="min-width:75px;max-width: 75px;">{{detail.date | date: 'EEE'}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="date">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:150px;max-width: 250px;"><span translate>Date</span></mat-header-cell>
        <mat-cell *matCellDef="let detail" style="min-width:150px;max-width: 250px;">{{detail.date | date: 'MM/dd/yy'}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="attCode">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:150px;max-width: 250px;"><span translate>Code</span></mat-header-cell>
        <mat-cell *matCellDef="let detail" style="min-width:150px;max-width: 250px;">{{detail.attCode}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="attDescription">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:150px;max-width: 250px;"><span translate>Description</span></mat-header-cell>
        <mat-cell *matCellDef="let detail" style="min-width:150px;max-width: 250px;">{{detail.attDescription}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="type">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:150px;max-width: 250px;">
            <span translate>Type</span></mat-header-cell>
        <mat-cell *matCellDef="let detail" style="min-width:150px;max-width: 250px;">{{detail.type}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="ampm">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:150px;"><span translate>AM/PM</span></mat-header-cell>
        <mat-cell *matCellDef="let detail" style="min-width:150px;">{{detail.ampm}}</mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="columnsToDisplay">
    </mat-header-row>
    <mat-row *matRowDef="let row; columns: columnsToDisplay" tabindex="0" [attr.aria-label]="getAriaDetailRowByTeamAttendanceDetails(row)">    
    </mat-row>
</mat-table>
